/**
 * Result Video Block JavaScript
 * Video injection and lazy loading - same pattern as header-full-screen
 * Desktop: inject from template, lazy load, play on scroll
 * Mobile: play mobile video when user scrolls to it
 */

(function() {
    'use strict';

    const DESKTOP_BREAKPOINT = 768;

    function initResultVideo() {
        const blocks = document.querySelectorAll('.result-video');

        blocks.forEach(block => {
            if (window.innerWidth >= DESKTOP_BREAKPOINT) {
                injectAndLazyLoadVideo(block);
            } else {
                initMobileVideoScrollToPlay(block);
            }
        });
    }

    /**
     * Play mobile video when user scrolls to it, pause when scrolled away.
     */
    function initMobileVideoScrollToPlay(block) {
        const mobileVideo = block.querySelector('.result-video__mobile-video-bg');
        if (!mobileVideo) return;

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    mobileVideo.play();
                } else {
                    mobileVideo.pause();
                }
            });
        }, { rootMargin: '100px', threshold: 0.25 });

        observer.observe(block);
    }

    /**
     * Inject video from template only on desktop, then lazy load it.
     * On mobile, video stays in template (mobile video container handles display).
     */
    function injectAndLazyLoadVideo(block) {
        if (block.querySelector('.result-video__video-bg')) return;

        const template = block.querySelector('.result-video-video-template');
        if (!template || !template.content) return;

        const video = template.content.querySelector('video');
        if (!video) return;

        const clone = template.content.cloneNode(true);
        const clonedVideo = clone.querySelector('video');
        clonedVideo.style.opacity = '0';
        const videoContainer = block.querySelector('.result-video__video-container');
        const insertTarget = videoContainer || block;
        insertTarget.insertBefore(clone, insertTarget.firstChild);

        function fadeInVideo() {
            clonedVideo.style.opacity = '1';
        }

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const sources = clonedVideo.querySelectorAll('source[data-src]');
                    sources.forEach(source => {
                        source.src = source.dataset.src;
                        source.removeAttribute('data-src');
                    });
                    clonedVideo.load();
                    clonedVideo.play();

                    if (clonedVideo.readyState >= 2) {
                        fadeInVideo();
                    } else {
                        clonedVideo.addEventListener('loadeddata', fadeInVideo, { once: true });
                    }

                    observer.unobserve(clonedVideo);
                }
            });
        }, { rootMargin: '200px' });

        observer.observe(clonedVideo);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initResultVideo);
    } else {
        initResultVideo();
    }

    // Re-init on resize (e.g. rotation) to switch between mobile/desktop logic
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(initResultVideo, 250);
    });
})();
